import React, { useRef, useState, useEffect } from 'react';

import './StyledTooltip.global.scss';

import './index.d.ts';

import Tooltip, { TooltipProps } from 'react-tooltip-lite';

interface Props extends TooltipProps {
  closeOnOutsideClick?: boolean;
}

/**
 * This class adds better SVG arrow for tooltip and includes CSS.
 * Also extends original Tooltip with `closeOnOutsideClick` but in a hacky way (react-tooltip-lite module doesn't use
 * ref forwarding and doesn't fire onToggle when isOpen is changed from outside)
 */
const StyledTooltip: React.FC<Props> = ({
  content,
  closeOnOutsideClick,
  onToggle,
  children,
  tipContentClassName,
  ...props
}) => {
  const [open, setOpen] = useState(false);
  const ref = useRef();

  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event) {
      // eslint-disable-next-line @typescript-eslint/ban-ts-comment
      // @ts-ignore
      if (!ref?.current?.contains(event.target)) {
        setOpen(false);
      }
    }
    if (closeOnOutsideClick) {
      document.addEventListener('mousedown', handleClickOutside);
      return () => {
        document.removeEventListener('mousedown', handleClickOutside);
      };
    }
  }, [ref, closeOnOutsideClick]);

  useEffect(() => {
    if (closeOnOutsideClick && onToggle) {
      onToggle(open);
    }
  }, [open, closeOnOutsideClick, onToggle]);

  const handleOnToggle = state => {
    if (!open) setOpen(state);
    if (!closeOnOutsideClick && onToggle) {
      onToggle(state);
    }
  };

  return (
    <Tooltip
      content={
        <div ref={ref} className="padding">
          {content}
        </div>
      }
      tipContentClassName={tipContentClassName || 'arrow-content-tooltip'}
      {...(closeOnOutsideClick && { isOpen: open, eventOff: 'onMouseOut' })}
      onToggle={handleOnToggle}
      arrowContent={
        <svg style={{ display: 'block' }} viewBox="0 0 21 11" width="20px" height="10px">
          <path
            d="M0,11 L9.43630703,1.0733987 L9.43630703,1.0733987 C10.1266203,0.3284971 11.2459708,0 11.936284,1.0733987 L20,11"
            style={{ stroke: '#CCD4E2', fill: 'white' }}
          />
        </svg>
      }
      padding="12px 15px"
      {...props}
    >
      <div>{children}</div>
    </Tooltip>
  );
};

export default StyledTooltip;
